import {
  DetailItemIcon,
  DetailItemType,
} from "components/UnityViewer/components/Manual/components/viewControlsCard/components/ControlsCard/ControlsCard";
import orbitIcon from "../assets/images/icons/vtSplash/orbit.png";
import panIcon from "../assets/images/icons/vtSplash/pan.png";
import pcIcon from "../assets/images/icons/vtSplash/pc.png";
import phoneIcon from "../assets/images/icons/vtSplash/phone.png";
import keyboardIcon from "../assets/images/icons/vtSplash/keyboard.svg";
import keyboardOrbitIcon from "../assets/images/icons/vtSplash/keyboardOrbitControls.svg";
import keyboardPanIcon from "../assets/images/icons/vtSplash/keyboardPanControls.svg";
import zoomIcon from "../assets/images/icons/vtSplash/zoom.png";
import { MdAdsClick } from "react-icons/md";
import {
  PiMouseLeftClickFill,
  PiMouseMiddleClickFill,
  PiMouseRightClickFill,
} from "react-icons/pi";
import { TbHandClick, TbHandMove, TbHandTwoFingers } from "react-icons/tb";

export const manual: {
  headers: DetailItemIcon[];
  rows: Array<DetailItemType[]>;
} = {
  headers: [
    {
      icon: null,
    },
    {
      customIconSrc: pcIcon,
    },
    {
      customIconSrc: phoneIcon,
    },
    {
      customIconSrc: keyboardIcon,
    },
  ],
  rows: [
    [
      {
        customIconSrc: orbitIcon,
        caption: "Orbit",
      },
      {
        icon: PiMouseRightClickFill,
        caption: "Right mouse button click and move forwards or backwards",
      },
      {
        icon: TbHandMove,
        caption: "Touch with one finger and move around",
      },
      {
        customIconSrc: keyboardOrbitIcon,
        caption: "WASD keys to move forward, left, backward & right ",
      },
    ],
    [
      {
        customIconSrc: zoomIcon,
        caption: "Zoom",
      },
      {
        icon: PiMouseMiddleClickFill,
        caption: "Move wheel back and forth",
      },
      {
        icon: TbHandTwoFingers,
        caption: "Touch with two fingers and widen them",
      },
      {
        customIconSrc: keyboardPanIcon,
        caption: "Arrow keys to adjust your view ",
      },
    ],
    [
      {
        customIconSrc: panIcon,
        caption: "Pan",
      },
      {
        icon: PiMouseMiddleClickFill,
        caption:
          "Press the mouse wheel button and move horizontally or vertically",
      },
      {
        icon: TbHandTwoFingers,
        caption: "Touch with two fingers and move them",
      },
      {
        icon: null,
        caption: undefined,
      },
    ],
    [
      {
        icon: MdAdsClick,
        caption: "Selection",
      },
      {
        icon: PiMouseLeftClickFill,
        caption: "Left mouse button click",
      },
      {
        icon: TbHandClick,
        caption: "Touch with a finger",
      },
      {
        icon: null,
        caption: undefined,
      },
    ],
  ],
};

export const views = [
  {
    title: "Dollhouse",
    description: "View",
  },
  {
    title: "FloorPlan",
    description: "View",
  },
  {
    title: "Virtual Tour",
    description: "View",
  },
  {
    title: "Comparison",
    description: "Mode",
  },
];

export const manualHeader = [
  {
    type: "view",
    description: "Views and Controls",
  },
  {
    type: "annotation",
    description: "Annotations",
  },
  {
    type: "measurement",
    description: "Measurements",
  },
];
